<form [formGroup]="columnForm" class="edit-menu-form">
  <!-- Base column type Select and Required Option -->
  <div class="form-group">
    <div class="row">
      <div class="col-6">
        <label for="baseColumnType">
          <span translate>Column Type</span>
          <scitis-required-field-indicator></scitis-required-field-indicator>
        </label>
      </div>
    </div>
    <div class="form-group">
      <ng-select (change)="onColumnTypeChange()"
        [clearable]="false"
        [items]="baseColumnTypes"
        [placeholder]="'Select base column type ...'|translate"
        [searchable]="false"
        [ngClass]="{'is-invalid': f.baseColumnType.errors}"
        formControlName="baseColumnType"
        id="baseColumnType">
        <ng-template let-item="item" ng-label-tmp>
          <span [innerHTML]="item|translate"></span>
        </ng-template>

        <ng-template let-item="item" ng-option-tmp>
          <span class="d-block" [innerText]="item|translate"></span>
        </ng-template>

      </ng-select>
      @if (f.baseColumnType.errors) {
        <div class="invalid-feedback">
          @if (f.baseColumnType.errors.required) {
            <span
            translate>Selection of base column type is required</span>
          }
        </div>
      }
    </div>
  </div>

  <!-- default type Select and Required Option -->
  <scitis-edit-column-input [show]="isDefaultType()"
    [last]="last"
    [label]="'Default Type'"
    (ngModelChange)="onDefaultColumnTypeChange($event)"
    [placeholder]="'Select default column type ...'"
    [bindLabel]="'value.label'"
    [bindValue]="'value.value'"
    formControlName="defaultColumnType"
    [errorRequiredMessage]="'Selection of default column type is required'|translate"
    [items]="defaultColumnTypes | keyvalue"
    [translateItems]="true">

  </scitis-edit-column-input>

  @if (f.defaultColumnType.errors) {
    <div class="invalid-feedback">
      @if (f.defaultColumnType.errors.required) {
        <span
        translate>Selection of default column type is required</span>
      }
      @if (f.defaultColumnType.errors.duplicatedColumns) {
        <span
        translate>This type of column does already exist</span>
      }
    </div>
  }

  <!-- metadata type Select and Required Option -->

  <scitis-edit-column-input [show]="isMetadataType()"
    (ngModelChange)="onMetadataColumnTypeChange($event)"
    [last]="last"
    [isLoadingItems]="isLoadingMachine"
    [items]="metaDataForRefMachine"
    [placeholder]="'Select metadata property ...'"
    [bindLabel]="'key'"
    formControlName="metadataColumnType"
    [errorRequiredMessage]="'Selection of metadata column type is required'|translate"
    [label]="'Metadata property'">

  </scitis-edit-column-input>
  @if (f.metadataColumnType.errors) {
    <div class="invalid-feedback">
      @if (f.metadataColumnType.errors.required) {
        <span
        translate>Selection of metadata is required</span>
      }
      @if (f.metadataColumnType.errors.duplicatedColumns) {
        <span
        translate>This type of column does already exist</span>
      }
    </div>
  }

  <!-- signal type Select and Required Option -->
  <scitis-edit-column-input [show]="isSignalType()"
    [last]="last"
    (ngModelChange)="onSignalColumnTypeChange($event)"
    [isLoadingItems]="isLoadingMachine"
    [items]="signalsForRefMachine | keyvalue"
    [placeholder]="'Select signal ...'"
    [bindLabel]="'key'"
    [bindValue]="'key'"
    [errorRequiredMessage]="'Selection of signal column type is required'|translate"
    formControlName="signalColumnType"
  [label]="'Signal'"></scitis-edit-column-input>
  @if (f.signalColumnType.errors) {
    <div class="invalid-feedback">
      @if (f.signalColumnType.errors.required) {
        <span
        translate>Selection of signal is required</span>
      }
      @if (f.signalColumnType.errors.duplicatedColumns) {
        <span
        translate>This type of column does already exist</span>
      }
    </div>
  }

  @if (isSignalType()) {
    <div class="form-check mt-2">
      <label class="form-check-label">
        <input (change)="onSignalSortableChange()"
          class="form-check-input"
          formControlName="sortable"
          type="checkbox">
        <span translate>Enable sorting for this signal</span>
      </label>
    </div>
  }
</form>
